export interface IDictionary {
  code(value: string): string | undefined;
  value(code: string): string | undefined;
  list(): Array<{ code: string; name: string }>;
}

export default class Dictionary implements IDictionary {
  constructor(private dictionary: Record<string, string>) {}

  private objectKeys<T>(obj: T): Array<keyof T> {
    const keys = Object.keys(obj);
    return keys as Array<keyof T>;
  }

  code(value: string) {
    return this.objectKeys(this.dictionary).find(
      (key) => this.dictionary[key] === value
    );
  }

  value(code: string) {
    return this.dictionary[code];
  }

  list() {
    return this.objectKeys(this.dictionary).map((key) => ({
      code: key,
      name: this.dictionary[key],
    }));
  }
}
